import { Component, Input, OnInit } from '@angular/core';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';

import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import IJob from '../../../_interfaces/IJob';
import { ValidatorService } from '../../../_services/validators/validator.service';
import { JobsService } from '../../../_services/jobs/jobs.service';
import { ErrorsService } from '../../../_services/errors/errors.service';
import { SessionService } from '../../../_services/session/session.service';
import { FormBase } from '../../../_classes/form-base.class';
import { Observable } from 'rxjs';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { ToastModule } from 'primeng/toast';
import { EResources } from '../../../_resources/EResources';
import { AdminFormActionsComponent } from '../../admin-ui/admin-form-actions/admin-form-actions.component';

@Component({
  standalone: true,
  selector: 'app-form-job',
  templateUrl: './form-job.component.html',
  styleUrls: ['./form-job.component.scss'],
  imports: [
    TranslatePipe,

    FormsModule,
    CommonModule,
    InputTextModule,
    ToastModule,
    ButtonModule,
    AdminFormActionsComponent,
  ],
})
export class FormJobComponent
  extends FormBase<IJob>
  implements OnInit, FormBase<IJob>
{
  @Input() showIntro = true;
  public submitting = false;

  constructor(
    public messageService: MessageService,
    public validationService: ValidatorService,
    public jobService: JobsService,
    public errorsService: ErrorsService,
    public translate: TranslateService,
    public session: SessionService
  ) {
    super(session, messageService, translate);
  }

  clear(): void {
    this.payload = {
      name: '',
    };
  }
  async validate(): Promise<void> {
    return this.validationService.job(this.payload);
  }

  updateFn(payload: IJob): Observable<any> {
    const jobId = +(this.id || payload?.id || 0);
    return this.jobService.update(
      this.customers_id,
      jobId,
      payload
    );
  }
  createFn(payload: IJob): Observable<any> {
    return this.jobService.create(this.customers_id, payload);
  }
  generatePayload(): IJob {
    return {
      name: (this.payload?.name || '').trim(),
    };
  }
  getResourceName(): string {
    return EResources.JOBS;
  }
  properties(): string[] {
    return ['name'];
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  override async execute(): Promise<void> {
    this.submitting = true;
    try {
      await super.execute();
    } finally {
      this.submitting = false;
    }
  }

  get formTitleKey(): string {
    return this.mode === 'edit' ? 'COMMON.JOB' : 'ADMIN.JOBS.ADD.TITLE';
  }

  get formDescriptionKey(): string {
    return this.mode === 'edit' ? 'ADMIN.IA.JOBS.DESCRIPTION' : 'ADMIN.IA.JOBS.DESCRIPTION';
  }
}
